import { useLang } from "@/i18n/LanguageContext";

const Process = () => {
  const { t } = useLang();
  const items = t("process.items");

  return (
    <section
      id="process"
      data-testid="process-section"
      className="relative bg-[#0e0e0e] py-24 md:py-32 border-t border-[#1f1f1f] overflow-hidden"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="grid lg:grid-cols-12 gap-12 mb-14">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3 mb-6">
              <span className="w-10 h-px bg-[#dc2626]" />
              <p className="font-mono text-xs tracking-[0.3em] uppercase text-[#dc2626]">
                {t("process.tag")}
              </p>
            </div>
            <h2 className="font-display font-black uppercase tracking-tighter text-3xl md:text-5xl lg:text-6xl leading-[0.95]">
              {t("process.heading")}
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-[#1f1f1f]">
          {items.map((p, i) => (
            <div
              key={i}
              data-testid={`process-step-${i}`}
              className="bg-[#0e0e0e] p-8 md:p-10 min-h-[260px] flex flex-col group"
            >
              <p className="font-display font-black text-6xl md:text-7xl text-[#1f1f1f] group-hover:text-[#dc2626] transition-colors duration-500">
                {p.n}
              </p>
              <div className="w-8 h-px bg-[#dc2626] my-6" />
              <h3 className="font-display font-bold uppercase tracking-tight text-lg md:text-xl mb-3">
                {p.title}
              </h3>
              <p className="text-sm text-[#a1a1aa] leading-relaxed">{p.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Process;
